import { render, staticRenderFns } from "./GateHint.vue?vue&type=template&id=9858f72a&scoped=true"
import script from "./GateHint.vue?vue&type=script&lang=js"
export * from "./GateHint.vue?vue&type=script&lang=js"
import style0 from "./GateHint.vue?vue&type=style&index=0&id=9858f72a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9858f72a",
  null
  
)

export default component.exports